import React, { Component } from "react";
import { connect } from "react-redux";
import spinner from '../Asset/loading.svg'

class PageLoader extends Component {
  state = {};
  render() {
    const { loading } = this.props;

    if (!loading) return null;

    return (
      <div className="App">
        <div className="spinner_overlay" >
          <div className="loader">
            <img src={spinner} alt="loading..." /><span><h3>Loading...</h3></span>
          </div>
        </div >
      </div>
    );
  }
}

const mapStateToProps = state => ({ loading: state.PageLoaderReducer.loading });

export default connect(mapStateToProps)(PageLoader);